var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodejsSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -99 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.1884411%",
    y1: "17.4868311%",
    x2: "27.8226935%",
    y2: "89.7551419%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418B3D",
    offset: "32.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#419637",
    offset: "63.52%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA92D",
    offset: "93.19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FAE2A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    d: "M57.903386,1.84920993 C56.0541761,0.809029345 53.8582393,0.809029345 52.0090293,1.84920993 L3.351693,29.9340858 C1.50248307,30.9742664 0.462302483,32.9390519 0.462302483,35.0194131 L0.462302483,91.3047404 C0.462302483,93.3851016 1.61805869,95.3498871 3.351693,96.3900677 L52.0090293,124.474944 C53.8582393,125.515124 56.0541761,125.515124 57.903386,124.474944 L106.560722,96.3900677 C108.409932,95.3498871 109.450113,93.3851016 109.450113,91.3047404 L109.450113,35.0194131 C109.450113,32.9390519 108.294357,30.9742664 106.560722,29.9340858 L57.903386,1.84920993 L57.903386,1.84920993 Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.2765472%",
    y1: "55.168777%",
    x2: "159.245277%",
    y2: "-18.3061379%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F",
    offset: "13.76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A044",
    offset: "40.32%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66B848",
    offset: "71.36%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC04A",
    offset: "90.81%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4413.77%",
    y1: "13.43%",
    x2: "5327.93%",
    y2: "13.43%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC04A",
    offset: "9.191646%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66B848",
    offset: "28.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A044",
    offset: "59.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F",
    offset: "86.24%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.38880435%",
    y1: "49.9972065%",
    x2: "101.499239%",
    y2: "49.9972065%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC04A",
    offset: "9.191646%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66B848",
    offset: "28.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A044",
    offset: "59.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F",
    offset: "86.24%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-9713.77%",
    y1: "36.21%",
    x2: "27.93%",
    y2: "36.21%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC04A",
    offset: "9.191646%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66B848",
    offset: "28.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A044",
    offset: "59.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F",
    offset: "86.24%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-103.860714%",
    y1: "50.2754209%",
    x2: "100.796849%",
    y2: "50.2754209%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CC04A",
    offset: "9.191646%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66B848",
    offset: "28.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A044",
    offset: "59.68%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F",
    offset: "86.24%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "130.613025%",
    y1: "-211.06936%",
    x2: "4.39327731%",
    y2: "201.605387%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418B3D",
    offset: "32.88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#419637",
    offset: "63.52%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA92D",
    offset: "93.19%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FAE2A",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.110609,313.094357 C251.376975,313.094357 249.758916,312.632054 248.256433,311.823025 L232.884876,302.692551 C230.573363,301.421219 231.72912,300.958916 232.422573,300.727765 C235.543115,299.687585 236.120993,299.456433 239.357111,297.607223 C239.703837,297.376072 240.16614,297.491648 240.512867,297.722799 L252.30158,304.772912 C252.763883,305.004063 253.341761,305.004063 253.688488,304.772912 L299.80316,278.074944 C300.265463,277.843792 300.496614,277.38149 300.496614,276.803612 L300.496614,223.523251 C300.496614,222.945372 300.265463,222.48307 299.80316,222.251919 L253.688488,195.669526 C253.226185,195.438375 252.648307,195.438375 252.30158,195.669526 L206.186907,222.251919 C205.724605,222.48307 205.493454,223.060948 205.493454,223.523251 L205.493454,276.803612 C205.493454,277.265914 205.724605,277.843792 206.186907,278.074944 L218.78465,285.356208 C225.603612,288.823476 229.87991,284.77833 229.87991,280.733183 L229.87991,228.146275 C229.87991,227.452822 230.457788,226.759368 231.266817,226.759368 L237.161174,226.759368 C237.854628,226.759368 238.548081,227.337246 238.548081,228.146275 L238.548081,280.733183 C238.548081,289.863657 233.57833,295.180135 224.910158,295.180135 C222.251919,295.180135 220.171558,295.180135 214.277201,292.290745 L202.141761,285.356208 C199.136795,283.622573 197.287585,280.386456 197.287585,276.919187 L197.287585,223.638826 C197.287585,220.171558 199.136795,216.93544 202.141761,215.201806 L248.256433,188.503837 C251.145824,186.885779 255.075395,186.885779 257.964786,188.503837 L304.079458,215.201806 C307.084424,216.93544 308.933634,220.171558 308.933634,223.638826 L308.933634,276.919187 C308.933634,280.386456 307.084424,283.622573 304.079458,285.356208 L257.964786,312.054176 C256.462302,312.74763 254.728668,313.094357 253.110609,313.094357 Z M267.326411,276.456885 C247.100677,276.456885 242.939955,267.210835 242.939955,259.351693 C242.939955,258.658239 243.517833,257.964786 244.326862,257.964786 L250.336795,257.964786 C251.030248,257.964786 251.608126,258.427088 251.608126,259.120542 C252.532731,265.24605 255.190971,268.251016 267.441986,268.251016 C277.150339,268.251016 281.311061,266.055079 281.311061,260.854176 C281.311061,257.84921 280.155305,255.653273 265.014898,254.15079 C252.417156,252.879458 244.558014,250.105643 244.558014,240.050564 C244.558014,230.688939 252.417156,225.141309 265.592777,225.141309 C280.386456,225.141309 287.66772,230.226637 288.592325,241.321896 C288.592325,241.668623 288.476749,242.01535 288.245598,242.362077 C288.014447,242.593228 287.66772,242.824379 287.320993,242.824379 L281.311061,242.824379 C280.733183,242.824379 280.155305,242.362077 280.039729,241.784199 C278.652822,235.42754 275.069977,233.347178 265.592777,233.347178 C254.959819,233.347178 253.688488,237.045598 253.688488,239.819413 C253.688488,243.171106 255.190971,244.211287 269.522348,246.060497 C283.738149,247.909707 290.441535,250.567946 290.441535,260.507449 C290.325959,270.678104 282.004515,276.456885 267.326411,276.456885 Z",
    fill: "#539E43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.027991,104.711512 C110.027991,102.631151 108.872235,100.666366 107.023025,99.6261851 L58.0189616,71.4257336 C57.2099323,70.9634312 56.2853273,70.7322799 55.3607223,70.6167043 L54.8984199,70.6167043 C53.9738149,70.6167043 53.0492099,70.9634312 52.2401806,71.4257336 L3.23611738,99.6261851 C1.38690745,100.666366 0.231151242,102.631151 0.231151242,104.711512 L0.346726862,180.52912 C0.346726862,181.5693 0.924604966,182.609481 1.84920993,183.071783 C2.7738149,183.649661 3.92957111,183.649661 4.73860045,183.071783 L33.8636569,166.428894 C35.7128668,165.388713 36.868623,163.423928 36.868623,161.343567 L36.868623,125.861851 C36.868623,123.78149 38.0243792,121.816704 39.8735892,120.776524 L52.2401806,113.610835 C53.1647856,113.032957 54.2049661,112.801806 55.2451467,112.801806 C56.2853273,112.801806 57.3255079,113.032957 58.1345372,113.610835 L70.5011287,120.776524 C72.3503386,121.816704 73.5060948,123.78149 73.5060948,125.861851 L73.5060948,161.343567 C73.5060948,163.423928 74.661851,165.388713 76.5110609,166.428894 L105.636117,183.071783 C106.560722,183.649661 107.716479,183.649661 108.641084,183.071783 C109.565688,182.609481 110.143567,181.5693 110.143567,180.52912 L110.027991,104.711512 L110.027991,104.711512 Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.571106,0.346726862 C344.646501,-0.115575621 343.490745,-0.115575621 342.681716,0.346726862 C341.757111,0.924604966 341.179233,1.84920993 341.179233,2.88939052 L341.179233,78.013544 C341.179233,78.7069977 340.832506,79.4004515 340.139052,79.862754 C339.445598,80.2094808 338.752144,80.2094808 338.058691,79.862754 L325.807675,72.8126411 C323.958465,71.7724605 321.762528,71.7724605 319.913318,72.8126411 L270.909255,101.128668 C269.060045,102.168849 267.904289,104.133634 267.904289,106.213995 L267.904289,162.730474 C267.904289,164.810835 269.060045,166.775621 270.909255,167.815801 L319.913318,196.131828 C321.762528,197.172009 323.958465,197.172009 325.807675,196.131828 L374.811738,167.815801 C376.660948,166.775621 377.816704,164.810835 377.816704,162.730474 L377.816704,21.8437923 C377.816704,19.6478555 376.660948,17.68307 374.811738,16.6428894 L345.571106,0.346726862 L345.571106,0.346726862 Z M341.063657,144.122799 C341.063657,144.700677 340.832506,145.16298 340.370203,145.394131 L323.611738,155.102483 C323.149436,155.333634 322.571558,155.333634 322.109255,155.102483 L305.35079,145.394131 C304.888488,145.16298 304.657336,144.585102 304.657336,144.122799 L304.657336,124.706095 C304.657336,124.128217 304.888488,123.665914 305.35079,123.434763 L322.109255,113.726411 C322.571558,113.49526 323.149436,113.49526 323.611738,113.726411 L340.370203,123.434763 C340.832506,123.665914 341.063657,124.243792 341.063657,124.706095 L341.063657,144.122799 L341.063657,144.122799 Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.047404, 70.501129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.600903,53.7426637 C109.450113,52.7024831 110.490293,50.7376975 110.490293,48.6573363 L110.490293,34.9038375 C110.490293,32.8234763 109.334537,30.8586907 107.600903,29.8185102 L58.9435666,1.61805869 C57.0943567,0.577878104 54.8984199,0.577878104 53.0492099,1.61805869 L4.04514673,29.9340858 C2.19593679,30.9742664 1.04018059,32.9390519 1.04018059,35.0194131 L1.04018059,91.5358916 C1.04018059,93.6162528 2.19593679,95.5810384 4.04514673,96.621219 L52.7024831,124.359368 C54.551693,125.399549 56.7476298,125.399549 58.4812641,124.359368 L87.9530474,107.94763 C88.8776524,107.485327 89.4555305,106.445147 89.4555305,105.404966 C89.4555305,104.364786 88.8776524,103.324605 87.9530474,102.862302 L38.717833,74.5462754 C37.793228,73.9683973 37.2153499,73.0437923 37.2153499,72.0036117 L37.2153499,54.3205418 C37.2153499,53.2803612 37.793228,52.2401806 38.717833,51.7778781 L54.0893905,42.9941309 C55.0139955,42.4162528 56.1697517,42.4162528 57.0943567,42.9941309 L72.4659142,51.7778781 C73.3905192,52.3557562 73.9683973,53.2803612 73.9683973,54.3205418 L73.9683973,68.1896163 C73.9683973,69.2297968 74.5462754,70.2699774 75.4708804,70.7322799 C76.3954853,71.310158 77.5512415,71.310158 78.4758465,70.7322799 L107.600903,53.7426637 L107.600903,53.7426637 Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2451467,51.0844244 C55.5918736,50.8532731 56.0541761,50.8532731 56.4009029,51.0844244 L65.7625282,56.5164786 C66.1092551,56.7476298 66.3404063,57.0943567 66.3404063,57.5566591 L66.3404063,68.4207675 C66.3404063,68.88307 66.1092551,69.2297968 65.7625282,69.4609481 L56.4009029,74.8930023 C56.0541761,75.1241535 55.5918736,75.1241535 55.2451467,74.8930023 L45.8835214,69.4609481 C45.5367946,69.2297968 45.3056433,68.88307 45.3056433,68.4207675 L45.3056433,57.5566591 C45.3056433,57.0943567 45.5367946,56.7476298 45.8835214,56.5164786 L55.2451467,51.0844244 L55.2451467,51.0844244 Z",
    fill: "#539E43"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.067720, 70.501129)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8934537,1.84920993 L3.12054176,29.9340858 C1.27133183,30.9742664 0,32.9390519 0,35.0194131 L0,91.3047404 C0,92.6916479 0.577878104,93.9629797 1.50248307,95.0031603 L56.2853273,1.15575621 C54.8984199,0.924604966 53.2803612,1.04018059 51.8934537,1.84920993 L51.8934537,1.84920993 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6320542,125.052822 C57.0943567,124.937246 57.5566591,124.706095 58.0189616,124.474944 L106.791874,96.3900677 C108.641084,95.3498871 109.79684,93.3851016 109.79684,91.3047404 L109.79684,35.0194131 C109.79684,33.51693 109.103386,32.014447 108.063205,30.9742664 L56.6320542,125.052822 L56.6320542,125.052822 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.676298,29.9340858 L57.7878104,1.84920993 C57.3255079,1.61805869 56.7476298,1.38690745 56.2853273,1.27133183 L1.50248307,95.1187359 C1.96478555,95.696614 2.54266366,96.1589165 3.12054176,96.5056433 L52.0090293,124.590519 C53.3959368,125.399549 55.0139955,125.6307 56.5164786,125.168397 L107.94763,31.089842 C107.600903,30.6275395 107.1386,30.2808126 106.676298,29.9340858 L106.676298,29.9340858 Z",
    fill: "url(#linearGradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -9.246050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.79684,100.55079 L109.79684,44.2654628 C109.79684,42.1851016 108.525508,40.220316 106.676298,39.1801354 L57.7878104,11.0952596 C57.2099323,10.7485327 56.6320542,10.5173815 55.9386005,10.4018059 L109.450113,101.822122 C109.681264,101.475395 109.79684,101.013093 109.79684,100.55079 L109.79684,100.55079 Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12054176,39.1801354 C1.27133183,40.220316 0,42.1851016 0,44.2654628 L0,100.55079 C0,102.631151 1.38690745,104.595937 3.12054176,105.636117 L52.0090293,133.720993 C53.1647856,134.414447 54.4361174,134.645598 55.8230248,134.414447 L3.46726862,39.0645598 L3.12054176,39.1801354 L3.12054176,39.1801354 Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-5)",
    fillRule: "evenodd",
    d: "M50.3909707,0.809029345 L49.6975169,1.15575621 L50.6221219,1.15575621 L50.3909707,0.809029345 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.791874,105.636117 C108.178781,104.827088 109.218962,103.440181 109.681264,101.937698 L56.0541761,10.4018059 C54.6672686,10.1706546 53.1647856,10.2862302 51.8934537,11.0952596 L3.351693,39.0645598 L55.7074492,134.530023 C56.4009029,134.414447 57.2099323,134.183296 57.903386,133.836569 L106.791874,105.636117 L106.791874,105.636117 Z",
    fill: "url(#linearGradient-6)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-7)",
    fillRule: "evenodd",
    d: "M111.299323,104.711512 L110.952596,104.133634 L110.952596,104.942664 L111.299323,104.711512 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.791874,105.636117 L58.0189616,133.720993 C57.3255079,134.06772 56.6320542,134.298871 55.8230248,134.414447 L56.7476298,136.148081 L110.83702,104.827088 L110.83702,104.133634 L109.450113,101.822122 C109.218962,103.440181 108.178781,104.827088 106.791874,105.636117 L106.791874,105.636117 Z",
    fill: "url(#linearGradient-8)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.791874,105.636117 L58.0189616,133.720993 C57.3255079,134.06772 56.6320542,134.298871 55.8230248,134.414447 L56.7476298,136.148081 L110.83702,104.827088 L110.83702,104.133634 L109.450113,101.822122 C109.218962,103.440181 108.178781,104.827088 106.791874,105.636117 L106.791874,105.636117 Z",
    fill: "url(#linearGradient-9)",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejsSvgrepoCom);
export default __webpack_public_path__ + "static/media/nodejs-svgrepo-com.b0d6c7cead1cf51d8ac0b40bf3637dce.svg";
export { ForwardRef as ReactComponent };